import {Card, Grid, Heading} from '@primer/react-brand'
import type {ImageLinkItem} from '../../types'
import {renderWithNoMarks} from '../../utils'
import type {Document} from '@contentful/rich-text-types'

export type FlexSuiteLargeCardsProps = {
  heading?: Document
  cards?: ImageLinkItem[]
}

// This custom implementation will be replaced with a new Primer Brand Component, when available.
export function FlexSuiteLargeCards({heading, cards}: FlexSuiteLargeCardsProps) {
  if (!cards?.length) return null

  return (
    <Grid>
      {heading && (
        <Grid.Column span={12}>
          <Heading as="h3">{renderWithNoMarks(heading)}</Heading>
        </Grid.Column>
      )}
      {cards.map(c => {
        const id = c.sys.id
        const card = c.fields
        const imageUrl = card.image?.fields.file.url

        return (
          <Grid.Column span={{small: 12, medium: 4}} key={id}>
            <Card href={card.href} variant="minimal">
              {card.label && <Card.Label>{card.label}</Card.Label>}
              {card.heading && (
                <Card.Heading>
                  {renderWithNoMarks(card.heading)}
                  {card.alt ? <span className="sr-only"> {card.alt}</span> : null}
                </Card.Heading>
              )}
              {card.description && <Card.Description>{renderWithNoMarks(card.description)}</Card.Description>}
              {imageUrl && (
                <Card.Image src={imageUrl} alt={card.image?.fields.description || ''} position="block-end" />
              )}
            </Card>
          </Grid.Column>
        )
      })}
    </Grid>
  )
}
